import * as React from 'react';
import styles from './index.less';
import FIcons from '@/components/FIcons';
import { FUtil } from '@freelog/tools-lib';
import ReactDOM from 'react-dom';

interface FGlobalLoadingProps {
  open: boolean;
  onOpened?: (promise: Promise<void>) => void;
  onClosed?: () => void;
}

function FGlobalLoading({ open, onOpened, onClosed }: FGlobalLoadingProps) {
  const refPromise = React.useRef<Promise<void> | null>(null);

  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(false);

  React.useEffect(() => {
    if (open) {
      if (!!refPromise.current) {
        return;
      }
      set$open(true);
      refPromise.current = new Promise<void>((resolve) => {
        // console.log('runPromise 3428905urj;oisdjflskdjlkfjlj');
        self.setTimeout(() => {
          // console.log(' resolvePromise 3428905urj;oisdjflskdjlkfjlj');
          resolve();
        }, 500);
      });
      onOpened?.(refPromise.current);
    } else {
      refPromise.current?.then(() => {
        // console.log('thenPromise 3428905urj;oisdjflskdjlkfjlj');
        set$open(false);
        refPromise.current = null;
        onClosed?.();
      });
    }
  }, [open]);

  if (!$open) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={styles.container}>
      <FIcons.FLoading style={{ fontSize: 64 }} />
    </div>,
    self.document.getElementById('FGlobalLoading') as HTMLElement,
  );
}

export default FGlobalLoading;

// function promise500ms(){
//   return new M
// }
